import {Component, HostListener, Input} from '@angular/core';
import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';
import {ESCAPE} from '@angular/cdk/keycodes';
import {CuiIconService} from '../../core/icon/icon.service';

@Component({
  selector: 'cui-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  animations: [
    trigger('slidein', [
      state('true', style({
        transform: 'translate3d(0, 0, 0)',
        visibility: 'visible',
      })),
      state('false', style({
        transform: 'translate3d(-100%, 0, 0)',
        visibility: 'hidden',
      })),
      transition('true <=> false', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
    ]),
    trigger('fadein', [
      state('true', style({
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        visibility: 'visible',
      })),
      state('false', style({
        backgroundColor: 'rgba(0, 0, 0, 0)',
        visibility: 'hidden',
      })),
      transition('true <=> false', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
    ])
  ]
})
export class CuiSidenavComponent {
  isOpen = false;

  constructor(iconService: CuiIconService) {
    iconService.useIcons( [
      'nav/close-white'
    ]);
  }

  close() {
    this.isOpen = false;
  }

  open() {
    this.isOpen = true;
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  @HostListener('window:keyup', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (this.isOpen && event.keyCode === ESCAPE) {
      this.close();
      event.stopPropagation();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/navigation/sidenav/sidenav.component.ts